interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  description: string;
  disabled?: boolean;
}

/** Một dòng cấu hình bật/tắt. */
export function Toggle({ checked, onChange, label, description, disabled = false }: ToggleProps) {
  return (
    <div className="border-line bg-canvas flex items-center justify-between rounded-lg border px-4 py-3">
      <div>
        <span className="text-ink block text-[13px] font-bold">{label}</span>
        <span className="text-ink-dim mt-0.5 block text-[11px]">{description}</span>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={onChange}
        className={`relative h-6 w-11 shrink-0 rounded-full transition-colors disabled:opacity-50 ${
          checked ? 'bg-success' : 'bg-ink-ghost'
        }`}
      >
        <span
          className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${
            checked ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </button>
    </div>
  );
}
